import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import debounce from 'lodash.debounce'
import Modal from 'components/modal'

import 'less/credit-incentive-modal.less'

const CreditIncentiveModal = props => {
  const debouncedSearch = debounce(props.fetchInterviewsList, 600)

  useEffect(() => {
    if (props.isCreditingSuccessful) {
      props.onClose()
      props.resetUpdateState()
      debouncedSearch()
    }
  }, [props.isCreditingSuccessful, props.onClose, props.resetUpdateState])

  const creditIncentive = () => {
    const payload = {
      timeSlotIds: [props.timeSlotId],
    }
    props.creditIncentive(payload)
  }

  return (
    <Modal
      isOpen={props.isOpen}
      className="credit-incentive-modal"
      submitBtnText={props.t('incentive.credit.confirm')}
      onCancel={props.onClose}
      enableSubmit={!props.isSubmitting}
      onSubmit={creditIncentive}
      isSubmitting={props.isSubmitting}
      type='confirm-dialog'
    >
      <div className="react-dialog-confirm-msg">
        <p> {`${props.t('incentive.credit.message')} ${props.currency}${props.incentive}?`}</p>
      </div>
    </Modal>
  )
}

const mapStateToProps = state => ({
  isSubmitting: state.creditIncentiveReducer.isCrediting,
  isCreditingSuccessful: state.creditIncentiveReducer.isCreditingSuccessful
})

const mapDispatchToProps = {
  creditIncentive: (payload) => ({ 
    type: 'CREDIT_INCENTIVE_REQUESTED', 
    payload 
  }),
  resetUpdateState: () => ({
    type: 'RESET_CREDIT_INCENTIVE_STATE'
  }),
  fetchInterviewsList: (payload) => ({
    type: 'FETCH_INTERVIEWS_LIST_REQUESTED',
    payload
  }),
}

export default connect(mapStateToProps, mapDispatchToProps)(CreditIncentiveModal)